export enum UnexpectedAnswer {
    positive = 'Yes',
    negative = 'No'
}
